import api from './api';

const authService = {
    login: async (username, password) => {
        const response = await api.post('/api/auth/login', { username, password });
        if (response.data.success) {
            localStorage.setItem('vms_token', response.data.token);
            localStorage.setItem('vms_user', JSON.stringify(response.data.user));
        }
        return response.data;
    },

    logout: async () => {
        try {
            await api.post('/api/auth/logout');
        } catch (error) {
            console.error('Logout error:', error);
        }
        localStorage.removeItem('vms_token');
        localStorage.removeItem('vms_user');
    },

    getCurrentUser: async () => {
        const response = await api.get('/api/auth/me');
        return response.data;
    },

    refreshToken: async () => {
        const response = await api.post('/api/auth/refresh');
        if (response.data.success) {
            localStorage.setItem('vms_token', response.data.token);
            localStorage.setItem('vms_user', JSON.stringify(response.data.user));
        }
        return response.data;
    },

    getStoredUser: () => {
        const userStr = localStorage.getItem('vms_user');
        return userStr ? JSON.parse(userStr) : null;
    },

    getToken: () => {
        return localStorage.getItem('vms_token');
    },

    isAuthenticated: () => {
        return !!localStorage.getItem('vms_token');
    }
};

export default authService;
